export default __webpack_public_path__ + "static/media/gallery9.1fe8cbbf.jpg";